// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Editing div.editing-body {
    padding: 0.25em;
    position: relative;
    /* titlebar: 2.5em */
    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    display: flex;
    flex-direction: column;
    height: 100%;
}

#Editing .editing-minimize-maximize {
    margin-left: 1em;
    cursor: pointer;
    padding: 0.25em;
}

#Editing div.editing-body > div:not(:last-child) {
    margin-bottom: 0.25em;
}

#Editing div.editing-body > div.editing-layer-selection,
#Editing div.editing-body > div.editing-feature-selection,
#Editing div.editing-body > div.ButtonBar {
    flex: 0 0 auto;
}

#Editing div.editing-body > div.AttributeForm {
    margin-top: 0.25em;
    padding-top: 0.5em;
    border-top: 1px solid var(--border-color);
    flex: 1 1 auto;
    overflow: hidden;
}

#Editing select.editing-layer-select,
#Editing select.editing-feature-select {
    width: 100%;
}

#Editing select.editing-layer-select:disabled,
#Editing select.editing-feature-select:disabled {
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Editing.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gFAAgF,EAAE,oDAAoD;IACtI,+FAA+F,EAAE,oDAAoD;IACrJ,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB","sourcesContent":["#Editing div.editing-body {\n    padding: 0.25em;\n    position: relative;\n    /* titlebar: 2.5em */\n    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n#Editing .editing-minimize-maximize {\n    margin-left: 1em;\n    cursor: pointer;\n    padding: 0.25em;\n}\n\n#Editing div.editing-body > div:not(:last-child) {\n    margin-bottom: 0.25em;\n}\n\n#Editing div.editing-body > div.editing-layer-selection,\n#Editing div.editing-body > div.editing-feature-selection,\n#Editing div.editing-body > div.ButtonBar {\n    flex: 0 0 auto;\n}\n\n#Editing div.editing-body > div.AttributeForm {\n    margin-top: 0.25em;\n    padding-top: 0.5em;\n    border-top: 1px solid var(--border-color);\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n#Editing select.editing-layer-select,\n#Editing select.editing-feature-select {\n    width: 100%;\n}\n\n#Editing select.editing-layer-select:disabled,\n#Editing select.editing-feature-select:disabled {\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
